import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Banners, GlobalBannerDescriptor } from '@/shared/types/banners';

const initialState: Banners = { props: null };

const slice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    openBanner: (state, action: PayloadAction<GlobalBannerDescriptor>) => {
      state.props = action.payload;
    },

    closeBanner: (state) => {
      state.props = null;
    },
  },
});

export const { openBanner, closeBanner } = slice.actions;
export default slice.reducer;
